import { Color } from 'modules/styles/colors';

export const fallback = {
  activeColor: Color.primary,
  completedColor: Color.primary,
  inactiveColor: Color.buttonDisabled
} as const;
